import { AlertTriangle, Ban, CheckCircle2, FolderOpen, Lock, Loader2, SearchX } from 'lucide-react'
import { resolveComponentVariant } from '../componentContract'
import { Button } from '../primitives/Button'
import styles from './Feedback.module.css'

const states = ['loading', 'empty', 'search-empty', 'error', 'success', 'disabled', 'restricted']
const icons = { loading: Loader2, empty: FolderOpen, 'search-empty': SearchX, error: AlertTriangle, success: CheckCircle2, disabled: Ban, restricted: Lock }

export function StatePanel({
  state = 'empty', title, description, icon, action, actionLabel, onAction,
  retryLabel = 'Retry', onRetry, clearLabel = 'Clear filters', onClear,
  undoLabel = 'Undo', onUndo, compact = false, children, className = '',
}) {
  const resolvedState = resolveComponentVariant('StatePanel state', state, states, 'empty')
  const Icon = icon || icons[resolvedState]
  const role = resolvedState === 'error' ? 'alert' : 'status'
  const toneClass = resolvedState === 'error' ? styles.stateError
    : resolvedState === 'success' ? styles.stateSuccess
      : resolvedState === 'restricted' ? styles.stateRestricted
        : resolvedState === 'disabled' ? styles.stateDisabled
          : resolvedState === 'loading' ? styles.stateLoading : ''

  return (
    <section className={`${styles.statePanel} ${toneClass} ${compact ? styles.stateCompact : ''} ${className}`.trim()} data-state={resolvedState} role={role} aria-live={resolvedState === 'loading' ? 'polite' : undefined}>
      <div className={styles.stateIcon}><Icon size={compact ? 18 : 22} aria-hidden="true" /></div>
      <div className={styles.stateContent}>
        {title ? <h3 className={styles.stateTitle}>{title}</h3> : null}
        {description ? <p className={styles.stateDescription}>{description}</p> : null}
        {children}
        {(action || onAction || onRetry || onClear || onUndo) ? (
          <div className={styles.stateActions}>
            {action}
            {!action && onAction ? <Button variant="secondary" onClick={onAction}>{actionLabel}</Button> : null}
            {onRetry ? <Button variant="secondary" onClick={onRetry}>{retryLabel}</Button> : null}
            {onClear ? <Button variant="ghost" onClick={onClear}>{clearLabel}</Button> : null}
            {onUndo ? <Button variant="ghost" onClick={onUndo}>{undoLabel}</Button> : null}
          </div>
        ) : null}
      </div>
    </section>
  )
}
